import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'

import MeScroll from 'mescroll.js'
import 'mescroll.js/mescroll.min.css'

export default {
name: 'invoiceInfo',
directives: {
TransferDom
},
components: {
Popup,
Timeline,
TimelineItem
},
data () {
return {
kdnames:[
{  expressCode: "shunfeng" , expressCompany: "顺丰"},
{  expressCode: "yuantong" ,expressCompany: "圆通速递" },
{  expressCode: "yunda"  ,expressCompany: "韵达快运" },
{  expressCode: "tiantian" ,expressCompany: "韵达快运" },
{  expressCode: "zhongtong" , expressCompany: "中通速递"},
{  expressCode: "shentong" ,expressCompany: "申通" }
],
dataList: [],
page: 1,
mescroll: null,
listType: 'valueAddedTaxInvoice',
listType2: 'valueAddedTaxInvoice',
invoiceType: '增值税专用发票',
showLogistics: false,

expressTrackDatas:[],
showInvoiceOrderList: false,
invoiceOrderList: [],
}
},
methods: {
fileLinkToStreamDownload(url, name) {
document.getElementById("downloadForm") .setAttribute("action",  baseURL + "/file/download");
document.getElementById("filePath").value = url;
document.getElementById("newFileName").value = name;
document.getElementById("token").value = this.getCookie();
document.getElementById("downloadForm").submit();
},
getkdnames(name){

let id=''
for(let i=0;i<this.kdnames.length;i++){
if(this.kdnames[i].expressCompany==name){
id=this.kdnames[i].expressCode


break

}


}
return id
},
xz(item){


let name=item.einvoicePath.split('/')[2]


if(name=='hlh-shopping-image.oss-cn-shenzhen.aliyuncs.com'){
this.fileLinkToStreamDownload(item.einvoicePath,'电子票.pdf')
}else{
const a = document.createElement("a");
a.href = item.einvoicePath+'?pdfjs.action=print_preview';
a.download = 'xxxx';
document.body.appendChild(a);
a.click();
a.remove();

}





},
toggleOrderVoucher (type) {
this.listType = ''
this.listType2 = type

this.listType = type

console.log(type)
if(type == 'valueAddedTaxInvoice'){
this.invoiceType = '增值税专用发票'
}else if(type == 'plainInvoice'){
this.invoiceType = '电子普通发票'
}else if(type == 'receipt'){
this.invoiceType = '收据'
}
this.getinvoiceDatas()


},

upCallback (page) {

this.getListDataFromNet(this.pdType, page.num, page.size, (arr) => {


if (page.num === 1) this.dataList = []

this.dataList = this.dataList.concat(arr)

this.$nextTick(() => {
this.mescroll.endSuccess(arr.length)

this.$vux.loading.hide()

})
}, () => {
this.mescroll.endErr()
})
},
/* 联网加载列表数据
* 在您的实际项目中,请参考官方写法: http://www.mescroll.com/api.html#tagUpCallback
* 请忽略getListDataFromNet的逻辑,这里仅仅是在本地模拟分页数据,本地演示用
* 实际项目以您服务器接口返回的数据为准,无需本地处理分页.
*/
getListDataFromNet (pdType, pageNum, pageSize, successCallback, errorCallback) {
console.log(22)
this.mescroll.lockUpScroll( false )
console.log(this.listType2)
if(this.listType2 == 'valueAddedTaxInvoice'){
this.$request.post('/invoice/listBasicByType',{

page: pageNum,
rows: pageSize
}).then(data => {
if(data.code == 0){
setTimeout(() => {

var listData = []
for (var i = (pageNum - 1) * pageSize; i < pageNum * pageSize; i++) {
if (i === data.obj.total) break
listData.push(data.obj.rows[i-(pageNum - 1) * pageSize])
}
successCallback(listData)
}, 350);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}else{
this.$request.post('/couponDetail/getInvitationCouponUserInfo',{
page: pageNum,
rows: pageSize
}).then(data => {
if(data.code == 0){
setTimeout(() => {

var listData = []
for (var i = (pageNum - 1) * pageSize; i < pageNum * pageSize; i++) {
if (i === data.obj.total) break
listData.push(data.obj.rows[i-(pageNum - 1) * pageSize])
}
successCallback(listData)
}, 350);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
}
},
initMescrollFun () {

this.mescroll = new MeScroll(this.$refs.mescroll, { // 在vue的mounted生命周期初始化mescroll,确保此处配置的ref有值
up: {
callback: this.upCallback,
htmlNodata: '<p class="upwarp-nodata">没有更多数据</p>',
page: {
num: 0, // 当前页码,默认0,回调之前会加1,即callback(page)会从1开始
size: 10 
},
noMoreSize: 1, // 如果列表已无数据,可设置列表的总数量要大于等于5条才显示无更多数据;避免列表数据过少(比如只有一条数据),显示无更多数据会不好看
toTop: { // 配置回到顶部按钮
src: require('../../assets/images/mescroll-totop.png'),
offset: 100
},
empty: {

warpId:	"dataList", //父布局的id (1.3.5版本支持传入dom元素)

tip: "暂无相关数据~", //提示
}



},
down: {
offset: 40,




}
})
},
noteThat () {
this.$router.push({
path: '/noteThat'
})
},
getinvoiceDatas () {
this.$request.post('/invoice/listBasicByType',{
invoiceType: this.invoiceType
}).then(data => {
if(data.code == 0){
this.dataList = data.obj
this.dataList.forEach((item, index) => {
if(!item.expressAmt){
item.expressAmt = 0
}
})
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
getExpressTrack (name,expressNumber,phone,obj) {  //获取物流信息
this.$request.post('/order/getExpressTrack',{
expressActualCode:this.getkdnames(name),
expressNumber,
phone:phone
}).then(data => {



if(data.code == 0){
data.obj['tx']=obj

this.expressTrackDatas.push(data.obj)


console.log('this.expressTrackDatas',this.expressTrackDatas);
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
logistics (item, index) {
console.log(JSON.parse(JSON.stringify(item)))

this.$request.post('/order/listOrderBasicByInvoceId',{
invoiceId:  item.id
}).then(data => {
if(data.code == 0){
this.expressTrackDatas=[]

for(let i=0;i<data.obj.length;i++){
this.getExpressTrack(data.obj[i].expressActualCompany,data.obj[i].expressNumber,data.obj[i].phone,data.obj[i])

}





this.showLogistics = true
}
})

},
getInvoiceOrderList (invoiceId) {  //获取物流信息
this.$request.post('/order/listOrderBasicByInvoceId',{
invoiceId
}).then(data => {
if(data.code == 0){
this.invoiceOrderList = {...data.obj}
console.log(JSON.parse(JSON.stringify(data.obj)))
}else{
this.$vux.toast.show({
type: 'cancel',
text: data.msg
})
}
}).catch(e => {
console.log(e)
})
},
detail (item, index) {
console.log(JSON.parse(JSON.stringify(item)))
this.showInvoiceOrderList = true
this.getInvoiceOrderList(item.id)

}
},
created () {
this.getinvoiceDatas()
},
mounted() {

},
beforeRouteEnter (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteEnter不用写
next(vm => {
if (vm.mescroll) {

if (vm.mescroll.lastBounce != null) vm.mescroll.setBounce(vm.mescroll.lastBounce)

if (vm.mescroll.lastScrollTop) {
vm.mescroll.setScrollTop(vm.mescroll.lastScrollTop)
setTimeout(() => { // 需延时,因为setScrollTop内部会触发onScroll,可能会渐显回到顶部按钮
vm.mescroll.setTopBtnFadeDuration(0)
}, 16)
}
}
})
},
beforeRouteLeave (to, from, next) { // 如果没有配置回到顶部按钮或isBounce,则beforeRouteLeave不用写
if (this.mescroll) {
this.mescroll.lastBounce = this.mescroll.optUp.isBounce
this.mescroll.setBounce(true) 
this.mescroll.lastScrollTop = this.mescroll.getScrollTop() 
this.mescroll.hideTopBtn(0)
}
next()
},
}



// WEBPACK FOOTER //
// ./src/views/invoiceInfo/script.js